function Icon1() {
  return (
    <svg id="icon1__Layer_1" data-name="Layer 1" viewBox="0 0 100 86">
      <defs>
        <style>{'.icon1__cls-1{fill:#0d1f43}'}</style>
      </defs>
      <path
        className="icon1__cls-1"
        d="M50.52 67.06h-34a1 1 0 000 2h34a1 1 0 100-2zm-14.35 5.66l-19.64-.21a1 1 0 00-1 1 1 1 0 001 1l19.64.21a1 1 0 000-2z"
      />
      <path
        className="icon1__cls-1"
        d="M82.35 56H11.18a7 7 0 00-7 7v15.8a7 7 0 007 7h71.17a7 7 0 007-7V63a7 7 0 00-7-7zm5 22.77a5 5 0 01-5 5H11.18a5 5 0 01-5-5V63a5 5 0 015-5h71.17a5 5 0 015 5z"
      />
      <path
        d="M91.29 48.82l-1.07-17.77a5.91 5.91 0 00-6.28-5.52L6 30.88a5.92 5.92 0 00-5.49 6.27l1.07 17.77a5.91 5.91 0 006.27 5.52l77.91-5.35a5.92 5.92 0 005.53-6.27z"
        fill="#b8e1f7"
      />
      <path
        className="icon1__cls-1"
        d="M98.35 19.36l-1.77.26a1 1 0 00-.64.38c0 .05-3.45 4.42-7.21 5.71-4 1.37-13.46 8.61-14.81 9.66l-8.31 2.5a2.72 2.72 0 01.13-1.63c.48-1.23 2.09-3 7.07-4.36a1 1 0 00.52-.35l1.38-1.73c3-3.78 4.85-6.07 5-8.27a11.23 11.23 0 00-2.87-7.37A3.91 3.91 0 0073.63 13c-3.4.43-11.43 4.8-11.77 5a1 1 0 00-.45.52c-.15.4-3.74 9.84-4.2 11.27a2.43 2.43 0 01-1.35 1.28L60 15.4l5.59-5.18a1 1 0 00-1.19-1.6c-.57.34-14 8.26-16.2 9.74-2 1.36-3.6 1.11-4.55.61 3.39-2 12.05-7.41 14.05-8.66a1 1 0 00.4-1.23 1 1 0 00-1.1-.59c-.09 0-9.08 2.09-10.9 2.34a3.5 3.5 0 01-3.65-1.44C45.82 8.54 55.9 6 64.05 4.32h.11a.88.88 0 00.4-.1 74.64 74.64 0 019.79-1.63c4-.13 13.2 3.09 13.29 3.12a1 1 0 00.9-.12l5.13-3.51a1 1 0 00.25-1.4 1 1 0 00-1.39-.26l-4.71 3.23C85.8 3 78.14.45 74.29.58A79.13 79.13 0 0063.8 2.32L47.66 3a1 1 0 00-.92 1.28 4.56 4.56 0 001 1.74c-3.85.94-6.64 1.65-7 1.73A1 1 0 0040.06 9a5.45 5.45 0 006.3 3.84c.85-.11 3.06-.58 5.29-1.07-4.7 2.92-9.55 5.89-10.07 6.14a1 1 0 00-.57.64 1 1 0 00.14.85c.77 1.09 3.9 3.54 8.21.65 1.08-.72 5.07-3.12 8.81-5.35l-4.64 17.35a1 1 0 00.84 1.25 4.7 4.7 0 004.74-2.89c.4-1.23 3.37-9.07 4-10.82 2.46-1.32 8.33-4.28 10.73-4.58a1.94 1.94 0 011.56.61 9.34 9.34 0 012.24 5.8c-.09 1.56-1.86 3.78-4.54 7.14L72 30c-4.48 1.3-7.21 3.15-8.11 5.52a4.76 4.76 0 00.34 4.08 1 1 0 00.84.45 1 1 0 00.29 0l9.35-2.82a1 1 0 00.33-.17c.1-.08 10.49-8.12 14.38-9.46 3.73-1.28 7-4.94 7.88-6.06l1.39-.21a1 1 0 10-.3-2zM51 5.16a1.87 1.87 0 01-1.44-.25l3.39-.14-1.65.4a.76.76 0 00-.3-.01z"
      />
      <path
        d="M48.17 39.18l-33.95 2.07a1 1 0 00.06 2h.06l34-2.07a1 1 0 00-.12-2zm-14.03 6.75l-19.62 1a1 1 0 00.05 2l19.62-1a1 1 0 10-.1-2z"
        fill="#fff"
      />
    </svg>
  );
}

export default Icon1;
